import { render, staticRenderFns } from "./ScopeOfWork.vue?vue&type=template&id=0355cc01&scoped=true&"
import script from "./ScopeOfWork.vue?vue&type=script&lang=js&"
export * from "./ScopeOfWork.vue?vue&type=script&lang=js&"
import style0 from "./ScopeOfWork.vue?vue&type=style&index=0&id=0355cc01&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0355cc01",
  null
  
)

export default component.exports